import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { Appeals } from '../Appeals';
import type { View } from '../components/Header';

export function AppealsPage({ view }: { view?: View }) {
  usePageTopBar({ breadcrumb: ['Denied & underpaid'] });
  return <Appeals {...(view ? { view } : {})} />;
}
